<template>

<com-item name="game.winrate" :size="size" :loading="loading" :is-empty="!active" title="Win Rate by Count">

	<template v-slot:about>

		<p>{{ your | capitalise }} win rate at each player count for this game.</p>

	</template>

	<template v-slot:stats>

		<app-visualisation-scatter :data="graph" v-if="active" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			graph: {
				datasets: [
					{
						data: [],
						labels: [],
						colors: [],
						size: 'large'
					}
				],
				axis: {
					points: true,
					x: {
						label: 'Plays',
						offset: true
					},
					y: {
						label: 'Win %',
						offset: true,
						max: 100
					}
				}
			}
		}

	},

	created: function() {

		this.visualise()

	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			var players = this.$store.getters['page/insights/game/players']
			return (players && players.winsByCount) ? players.winsByCount : []

		},

		active: function() {

			return this.data.length && !this.loading

		}

	},

	watch: {

		data: function() {

			this.visualise()

		}

	},

	methods: {

		visualise: function() {

			this.graph.datasets[0].data = []
			this.graph.datasets[0].labels = []
			this.graph.datasets[0].colors = []

			this.$_.each(this.data, function(item, index) {

				if (!item.total) return

				var winPercent = Math.floor((100 / item.total) * item.wins)

				this.graph.datasets[0].colors.push('#4881bb')
				this.graph.datasets[0].labels.push(item.count + 'p')

				this.graph.datasets[0].data.push({
					id: index,
					x: item.total,
					y: winPercent,
					tooltip: 'Players: ' + item.count + ' | Plays: ' + item.total + ' | Win %: ' + winPercent
				})

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>
